module.exports = __webpack_public_path__ + "sleep.521d0d90.png";